// Lib
import React, { ReactElement } from 'react';

// Components
import TextStylePopupContent from '../../../../workspace/toolbar/components/selectionTools/editorTools/textStylePopup/TextStylePopupContent';
import TableTextColorButton from './TableTextColorButton';

// Constants
import {
    TEXT_BACKGROUND_PRESETS,
    TEXT_COLOR_PRESETS,
} from '../../../../components/editor/plugins/textColor/textColorConstants';

// Utils
import { getElementDefaultColors } from '../../../../workspace/toolbar/components/selectionTools/editorTools/textStylePopup/textStylePopupUtils';

// Types
import { ImMNElement } from '../../../../../common/elements/elementModelTypes';

type TableTextStylePopupContentProps = {
    element: ImMNElement;
};

/**
 * Renders text style controls that apply to selected table cells.
 */
const TableTextStylePopupContent: React.FC<TableTextStylePopupContentProps> = ({ element }): ReactElement => {
    const { defaultTextColor, defaultBackgroundColor } = getElementDefaultColors(element) || {};

    return (
        <TextStylePopupContent
            showBlockStyleTools={false}
            blockStyleComponents={null}
            textColorComponents={
                <>
                    <TableTextColorButton
                        preset={null}
                        customTextColor={defaultTextColor}
                        customBackgroundColor={defaultBackgroundColor}
                    />
                    {Object.values(TEXT_COLOR_PRESETS).map((preset) => (
                        <TableTextColorButton
                            key={preset}
                            preset={preset}
                            customBackgroundColor={defaultBackgroundColor}
                        />
                    ))}
                </>
            }
            textHighlightComponents={
                <>
                    {Object.values(TEXT_BACKGROUND_PRESETS).map((preset) => (
                        <TableTextColorButton key={preset} preset={preset} />
                    ))}
                </>
            }
        />
    );
};

export default TableTextStylePopupContent;
